import ivanov_ivan from './ivanov-ivan.jpg'
import petrov_petr from './petrov-petr.jpg'
import kuzmin_aleksey from './kuzmin-aleksey.jpg'
import krikun_anton from './krikun-anton.jpg'

export { ivanov_ivan, petrov_petr, kuzmin_aleksey, krikun_anton }
